<template>
    <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important">
        <!-- 左边 -->
        <div style="margin: 5px; float: right">
            <el-button size="mini" type="success" @click="openModel">添加楼栋</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="name" label="楼栋" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <el-button @click="setClick(scope.row)" type="primary" size="mini">楼层设置</el-button>
                    <!-- <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <!-- <div style="float: right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div> -->

        <el-dialog :title="names" :visible.sync="dialogVisible" top="20px" :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="楼栋">
                        <el-input v-model="ruleForm.title" placeholder="请输入内容" style="width: 30%"></el-input>
                    </el-form-item>

                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button @click="subForm" size="small" type="primary">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="楼层设置" :visible.sync="dialogVisibles" top="20px" :append-to-body="true">
            <div style="margin: 5px; float: right">
                <el-button size="mini" type="success" @click="openModelbad">添加楼层</el-button>
            </div>
            <el-table :data="tableDatabed" border style="width: 100%" v-loading="bedloadings"
                ref="configurationTablebed">
                <el-table-column prop="name" label="楼层" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="pic" label="图片">
                    <!-- <template v-slot="scope">
                        <img :src="scope.row.pic" width="90" height="90">
                    </template> -->
                    <el-popover placement="right" trigger="click" width="120" slot-scope="scope">
                        <img :src="scope.row.pic" :alt="scope.row.pic" style="width:500px;" />
                        <img slot="reference" :src="scope.row.pic" :alt="scope.row.pic"
                            style="max-height: auto;max-width:100px;cursor:pointer;" />
                    </el-popover>
                </el-table-column>
                <el-table-column prop="update_time" label="添加时间" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button @click="handleClickbed(scope.row)" type="primary" size="mini">编辑</el-button>
                        <!-- <el-button @click="deleteClickbed(scope.row)" type="danger" size="mini">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog :title="badnames" :visible.sync="dialogVisibled" top="20px" :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForms" :rules="ruled" ref="ruleForms" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="楼层">
                        <el-input v-model="ruleForms.title" placeholder="请输入内容" style="width: 50%"></el-input>
                    </el-form-item>
                    <el-form-item label="楼层示意图">
                        <div>
                            <span v-if="!ruleForms.avatar" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-else :src="ruleForms.avatar" class="rounded"
                                style="width: 100px;height: 100px;cursor: pointer;" @click="chooseImage" />
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibled = false" size="small">取 消</el-button>
                <el-button @click="subFormbad" size="small" type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue";
    import common from "@/common/mixins/common.js";
    const WangEditor = () => import("@/components/wangEnduit/index");
    export default {
        inject: ["app", "layout"],
        props: ["operateProjectId"],
        mixins: [common],
        components: {
            buttonSearch,
            WangEditor
        },
        data() {
            return {
                tableData: [],
                loadings: false,
                height: null,
                pageSize: 15,
                curPage: 1,
                count: 0,
                names: "",
                dialogVisible: false,
                building_options: [],
                floor_options: [],
                room_options: [],
                room_cx_options: [],
                operateflag: "add",
                ruleForm: {
                    title: ''
                },
                rules: {},
                projectId: null,
                dialogVisibles: false,
                tableDatabed: [],
                bedloadings: false,
                roomid: "",
                badnames: "",
                dialogVisibled: false,
                sex_options: [{
                        id: 1,
                        name: '男'
                    },
                    {
                        id: 2,
                        name: '女'
                    }
                ],
                ruleForms: {
                    title: "",
                    avatar: "",
                },
                ruled: {},
                badid: "",

            };
        },
        computed: {},
        mounted() {
            let that = this;
            // 项目id
            that.ruleForm.project_id = that.operateProjectId;
            that.search();
        },
        methods: {
            // 富文本编辑器内部变更时回调父组件的方法
            changeEditor(param) {
                let that = this;
                that.ruleForm.describe = param;
            },
            search() {
                let that = this;
                axios
                    .post(
                        "/admin/lgProjectFloor/index", {
                            // limit: that.pageSize,
                            // page: that.curPage,
                            project_id: that.ruleForm.project_id
                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        that.tableData = response.data.data;
                        // that.count = response.data.data.total;
                    })
                    .catch((error) => {});
            },


            chooseImage(param) {
                this.app.chooseImage((res) => {
                    this.ruleForms.avatar = res[0].url
                }, 1)
            },

            openModel() {
                let that = this;
                that.names = "新增";
                that.operateflag = "add";
                that.ruleForm.title = ''
                that.dialogVisible = true;
            },
            subForm() {
                let that = this;
                if (that.names == "新增") {
                    axios
                        .post("/admin/lgProjectFloor/Madd", {
                            // id:that.names == "新增"?0:that.ruleForm.id,
                            pid: 0,
                            project_id: that.ruleForm.project_id,
                            name: that.ruleForm.title

                        }, {
                            token: true,
                        })
                        .then((response) => {
                            if (response.data.code == 200) {
                                that.search();
                                that.dialogVisible = false;
                            }
                        })
                        .catch((error) => {});
                }
                if (that.names == "编辑") {
                    axios
                        .post("/admin/lgProjectFloor/Medit", {
                            id: that.ruleForm.id,
                            pid: 0,
                            project_id: that.ruleForm.project_id,
                            name: that.ruleForm.title

                        }, {
                            token: true,
                        })
                        .then((response) => {
                            if (response.data.code == 200) {
                                that.search();
                                that.dialogVisible = false;
                            }
                        })
                        .catch((error) => {});
                }

            },
            handleClick(row) {
                let that = this;
                that.names = "编辑";
                that.operateflag = "edit";
                that.ruleForm.id = row.id;
                that.ruleForm.title = row.name
                that.ruleForm.project_id = row.project_id;
                that.dialogVisible = true;
            },
            deleteClick() {},
            setClick(row) {
                let that = this;
                that.dialogVisibles = true;
                that.roomid = row.id;
                that.bedloadings = true;
                axios
                    .post(
                        "/admin/lgProjectFloor/index", {
                            project_id: that.ruleForm.project_id,

                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        response.data.data.forEach(element => {
                            if (that.roomid == element.id) {

                                that.tableDatabed = element.child
                            }
                        });
                        that.bedloadings = false;
                    })
                    .catch((error) => {});
            },
            searchbegin() {
                let that = this;
                that.bedloadings = true;
                axios
                    .post(
                        "/admin/lgProjectFloor/index", {
                            project_id: that.ruleForm.project_id,

                        }, {
                            token: true,
                        }
                    )
                    .then((response) => {
                        response.data.data.forEach(element => {
                            if (that.roomid == element.id) {

                                that.tableDatabed = element.child
                            }
                        });
                        that.bedloadings = false;
                    })
                    .catch((error) => {});
            },
            openModelbad() {
                let that = this;
                that.dialogVisibled = true;
                that.badnames = "新增楼层设置";
                that.ruleForms.title = "";
                that.ruleForms.avatar = "";
            },
            subFormbad() {
                let that = this;
                if (that.badnames == "新增楼层设置") {
                    axios
                        .post(
                            "/admin/lgProjectFloor/Madd", {
                                // id: that.badnames == "新增楼层设置" ? 0 : that.badid,
                                pid: that.roomid,
                                name: that.ruleForms.title,
                                pic: that.ruleForms.avatar,
                            }, {
                                token: true,
                            }
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: response.data.msg,
                                });
                                that.dialogVisibled = false;
                                that.searchbegin();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {});
                }
                if (that.badnames == "修改楼层设置") {
                    axios
                        .post(
                            "/admin/lgProjectFloor/Medit", {
                                id: that.badid,
                                pid: that.roomid,
                                name: that.ruleForms.title,
                                pic: that.ruleForms.avatar,
                            }, {
                                token: true,
                            }
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: response.data.msg,
                                });
                                that.dialogVisibled = false;
                                that.searchbegin();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {});
                }

            },
            handleClickbed(row) {
                let that = this;
                that.dialogVisibled = true;
                that.badnames = "修改楼层设置";
                that.badid = row.id;
                that.ruleForms.title = row.name;
                that.ruleForms.avatar = row.pic;
            },
        },
    };
</script>

<style></style>